<div #accelaControlDiv [id]="this.getDivElementId()" class="accelaControl textinput" [formGroup]="this.controlRef.parent">
    <div class="dropdown">
        <label [for]="this.controlData.name" [id]="this.getLabelElementId()" [attr.data-required]="this.controlData.required">{{this.label}}</label>
        <p-dropdown #dropdownWrapper appendTo="body" [formControlName]="this.controlData.name" [name]="this.controlData.name" [inputId]="this.controlData.name+'Input'" i18n-aria-placeholder aria-placeholder="Select"
            [ariaLabelledBy]="this.getLabelElementId()"  [options]="this.controlData.options" [showClear]="true" [readonly]="this.controlData.readOnly || readonlyMode" i18n-placeholder placeholder="Select" [virtualScroll]="false" 
            [editable]="this.controlData.optionKey==='EDIT'" [id]="this.controlData.name"
            tooltipEvent="hover|focus" [accelaTooltip]="this.controlData.tooltip" [escape]="false" tooltipPosition="bottom"
            [attr.aria-required]="this.controlData.required" [required]="this.controlData.required" (onBlur)="emitBlurEvent($event)">
        </p-dropdown>
    </div>
</div>
<div *ngIf="!this.adminMode" class="validationFeedback">
    <!-- <span>{{this.controlRef.value | json}}</span> -->
    <small *ngIf="this.controlRef?.errors?.required && (this.controlRef?.touched || this.controlRef?.dirty)"
        class="ng-invalid p-invalid">
        {{this.getRequiredFieldValidationMsg()}}
    </small>
</div>
